import { apiRequest } from '../client'

export type ProductMeta = {
  tags?: {
    vegan?: boolean
    vegetarian?: boolean
    gluten_free?: boolean
    spicy?: boolean
    halal?: boolean // legacy, prefer porkFree
    porkFree?: boolean
    organic?: boolean
  }
  allergens?: Record<string, 0 | 1 | 2 | null>
  nutritionPer100?: {
    energyKj?: number | null
    energyKcal?: number | null
    fatG?: number | null
    saturatesG?: number | null
    carbohydrateG?: number | null
    sugarsG?: number | null
    proteinG?: number | null
    saltG?: number | null
  }
}

export const metaApi = {
  get: (sku: string) =>
    apiRequest<ProductMeta>(
      `/api/v0/admin/products/${encodeURIComponent(sku)}/meta`,
    ),

  upsert: (sku: string, payload: ProductMeta) =>
    apiRequest<{ ok: boolean }>(
      `/api/v0/admin/products/${encodeURIComponent(sku)}/meta`,
      {
        method: 'PUT',
        body: JSON.stringify(payload),
      },
    ),
}
